<div class="page-wrapper">
    <div class="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">
        <div class="d-flex gap-3 align-items-center">

            <H4 style="font-size: 18px; font-weight: bolder">ASSESSMENT REPORT</H4>
        </div>
    </div>

    <div class="admin-dashboard-cards">
        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/assessment-dashboard-cards/gray-card-bg.png')">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Assessment Handled
                    </span>
                </div>

                @if(assessmentCardData){
                <div class="card-value">
                    <p class="value">
                        {{assessmentCardData?.total?.totalCurrentCount | number }}
                    </p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }
            </div>
        </div>



        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/assessment-dashboard-cards/blue-card-bg.png')">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Approved Assessment
                    </span>
                </div>


                @if(assessmentCardData){
                <div class="card-value">
                    <p class="value">
                        {{assessmentCardData?.approved?.totalCurrentCount | number }}
                    </p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }

            </div>
        </div>


        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/assessment-dashboard-cards/green-card-bg.png')">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Paid Assessment
                    </span>
                </div>


                @if(assessmentCardData){
                <div class="card-value">
                    <p class="value">
                        {{assessmentCardData?.paid?.totalCurrentCount | number }}
                    </p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }

            </div>
        </div>

        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/assessment-dashboard-cards/yellow-card-bg.png')">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Pending Assessment
                    </span>
                </div>


                @if(assessmentCardData){
                <div class="card-value">
                    <p class="value">
                        {{assessmentCardData?.pending?.totalCurrentCount| number }}
                    </p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }

            </div>
        </div>

        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/assessment-dashboard-cards/gray-card-bg.png')">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Assessment Amount
                    </span>
                </div>


                @if(assessmentCardData){
                <div class="card-value">
                    <p class="value">
                        {{assessmentCardData?.total?.totalCurrentAmount | nairaCurrency }}
                    </p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }

            </div>
        </div>

        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/assessment-dashboard-cards/green-white-card-bg.png')">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Amount Paid
                    </span>
                </div>


                @if(assessmentCardData){
                <div class="card-value">
                    <p class="value">
                        {{assessmentCardData?.paid?.totalCurrentAmount | nairaCurrency }}
                    </p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }

            </div>
        </div>


        <!-- <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/assessment-dashboard-cards/red-white-card-bg.png')">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Amount Unpaid
                    </span>
                </div>


                @if(assessmentCardData){
                <div class="card-value">
                    <p class="value">
                        {{assessmentCardData?.unpaid?.totalCurrentAmount | nairaCurrency }}
                    </p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }

            </div>
        </div> -->
    </div>


    <div class="row gx-2 gy-2">
        <div class="col-xxxl-6">
            <div class="chart-wrapper ng2-chart-wrapper">
                <div class="top">
                    <span style="color: #93A3AB; font-size: 17px; font-weight: 500;">Assessment Trends</span>


                    <div class="filter">

                        <div class="item" [ngClass]="{'active': lineChartFilter == 'WEEK'}"
                            (click)="setLineChartFilter({periodStatus: 'WEEK'})">
                            This Week
                        </div>
                        <div class="item" [ngClass]="{'active': lineChartFilter == 'MONTH'}"
                            (click)="setLineChartFilter({periodStatus: 'MONTH'})">
                            This Month
                        </div>
                        <div class="item" [ngClass]="{'active': lineChartFilter == 'YEAR'}"
                            (click)="setLineChartFilter({periodStatus: 'YEAR'})">
                            This Year
                        </div>

                        <!-- <div class="item date-filter" [ngClass]="{'active': barChartFilter == 'DATE_RANGE'}">

                            <div class="toggle" role="button" (click)="picker.open()">
                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.67174 1.70312H1.67186C1.11958 1.70312 0.671875 2.10606 0.671875 2.60311V8.903C0.671875 9.40005 1.11958 9.80298 1.67186 9.80298H8.67174C9.22401 9.80298 9.67172 9.40005 9.67172 8.903V2.60311C9.67172 2.10606 9.22401 1.70312 8.67174 1.70312Z"
                                        stroke="#6B6C7E" stroke-width="0.8" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M7.17188 0.803711V2.60368" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.17188 0.803711V2.60368" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M0.671875 4.4043H9.67172" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                                <span class="current-filter">
                                    {{formatActiveFilterTitle(barChartFilter)}}
                                </span>

                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.67188 0.803711L4.86032 4.72335C4.83559 4.74883 4.80621 4.76904 4.77388 4.78283C4.74154 4.79661 4.70688 4.80371 4.67188 4.80371C4.63687 4.80371 4.60221 4.79661 4.56987 4.78283C4.53754 4.76904 4.50816 4.74883 4.48343 4.72335L0.671875 0.803711"
                                        stroke="#071655" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>

                            <mat-form-field>
                                <mat-date-range-input [dateFilter]="dateRangeFilter" [formGroup]="rangePickerForm"
                                    [rangePicker]="picker" #rangeInput>
                                    <input matStartDate placeholder="Start date" formControlName="startDate">
                                    <input matEndDate placeholder="End date" formControlName="endDate">
                                </mat-date-range-input>

                            </mat-form-field>
                            <mat-date-range-picker #picker (closed)="onBarChartFilterDateChange()"> </mat-date-range-picker>
                            <app-error-message [form]="rangePickerForm" controlName="endDate"></app-error-message>


                        </div> -->
                    </div>


                </div>

                <div class="graph mt-4">
                    <!-- <ngx-charts-line-chart [scheme]="lineChartColorScheme" [legend]="true" [xAxis]="showXAxis"
                        [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                        [legendTitle]="null" [autoScale]="false" [timeline]="" [results]="lineChartData"
                        [legendPosition]="legendPosition.Below">
                    </ngx-charts-line-chart> -->

                    <canvas id="lineChart">{{ lineChart }}</canvas>

                </div>
            </div>
        </div>

        <div class="col-xxxl-6">
            <div class="chart-wrapper ng2-chart-wrapper">
                <div class="top">
                    <span style="color: #93A3AB; font-size: 17px; font-weight: 500;">Assessment Breakdown</span>


                    <div class="filter">

                        <div class="item" [ngClass]="{'active': barChartFilter == 'WEEK'}"
                            (click)="setBarChartFilter({periodStatus: 'WEEK'})">
                            This Week
                        </div>
                        <div class="item" [ngClass]="{'active': barChartFilter == 'MONTH'}"
                            (click)="setBarChartFilter({periodStatus: 'MONTH'})">
                            This Month
                        </div>
                        <div class="item" [ngClass]="{'active': barChartFilter == 'YEAR'}"
                            (click)="setBarChartFilter({periodStatus: 'YEAR'})">
                            This Year
                        </div>

                        <!-- <div class="item date-filter" [ngClass]="{'active': barChartFilter == 'DATE_RANGE'}">

                            <div class="toggle" role="button" (click)="picker.open()">
                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.67174 1.70312H1.67186C1.11958 1.70312 0.671875 2.10606 0.671875 2.60311V8.903C0.671875 9.40005 1.11958 9.80298 1.67186 9.80298H8.67174C9.22401 9.80298 9.67172 9.40005 9.67172 8.903V2.60311C9.67172 2.10606 9.22401 1.70312 8.67174 1.70312Z"
                                        stroke="#6B6C7E" stroke-width="0.8" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M7.17188 0.803711V2.60368" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.17188 0.803711V2.60368" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M0.671875 4.4043H9.67172" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                                <span class="current-filter">
                                    {{formatActiveFilterTitle(barChartFilter)}}
                                </span>

                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.67188 0.803711L4.86032 4.72335C4.83559 4.74883 4.80621 4.76904 4.77388 4.78283C4.74154 4.79661 4.70688 4.80371 4.67188 4.80371C4.63687 4.80371 4.60221 4.79661 4.56987 4.78283C4.53754 4.76904 4.50816 4.74883 4.48343 4.72335L0.671875 0.803711"
                                        stroke="#071655" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>

                            <mat-form-field>
                                <mat-date-range-input [dateFilter]="dateRangeFilter" [formGroup]="rangePickerForm"
                                    [rangePicker]="picker" #rangeInput>
                                    <input matStartDate placeholder="Start date" formControlName="startDate">
                                    <input matEndDate placeholder="End date" formControlName="endDate">
                                </mat-date-range-input>

                            </mat-form-field>
                            <mat-date-range-picker #picker (closed)="onBarChartFilterDateChange()"> </mat-date-range-picker>
                            <app-error-message [form]="rangePickerForm" controlName="endDate"></app-error-message>


                        </div> -->
                    </div>


                </div>

                <div class="graph mt-4">
                    <!-- <ngx-charts-line-chart [scheme]="lineChartColorScheme" [legend]="true" [xAxis]="showXAxis"
                        [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                        [legendTitle]="null" [autoScale]="false" [timeline]="" [results]="lineChartData"
                        [legendPosition]="legendPosition.Below">
                    </ngx-charts-line-chart> -->

                    <canvas id="barChart">{{ barChart }}</canvas>

                </div>
            </div>
        </div>

        <div class="col-xxxl-6">
            <div class="chart-wrapper ng2-chart-wrapper">
                <div class="top">
                    <span style="color: #93A3AB; font-size: 17px; font-weight: 500;">Assessment Payment
                        Distribution</span>


                    <div class="filter">

                        <div class="item" [ngClass]="{'active': pieChartFilter == 'WEEK'}"
                            (click)="setPieChartFilter({periodStatus: 'WEEK'})">
                            This Week
                        </div>
                        <div class="item" [ngClass]="{'active': pieChartFilter == 'MONTH'}"
                            (click)="setPieChartFilter({periodStatus: 'MONTH'})">
                            This Month
                        </div>
                        <div class="item" [ngClass]="{'active': pieChartFilter == 'YEAR'}"
                            (click)="setPieChartFilter({periodStatus: 'YEAR'})">
                            This Year
                        </div>

                        <!-- <div class="item date-filter" [ngClass]="{'active': barChartFilter == 'DATE_RANGE'}">

                            <div class="toggle" role="button" (click)="picker.open()">
                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.67174 1.70312H1.67186C1.11958 1.70312 0.671875 2.10606 0.671875 2.60311V8.903C0.671875 9.40005 1.11958 9.80298 1.67186 9.80298H8.67174C9.22401 9.80298 9.67172 9.40005 9.67172 8.903V2.60311C9.67172 2.10606 9.22401 1.70312 8.67174 1.70312Z"
                                        stroke="#6B6C7E" stroke-width="0.8" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M7.17188 0.803711V2.60368" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.17188 0.803711V2.60368" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M0.671875 4.4043H9.67172" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                                <span class="current-filter">
                                    {{formatActiveFilterTitle(barChartFilter)}}
                                </span>

                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.67188 0.803711L4.86032 4.72335C4.83559 4.74883 4.80621 4.76904 4.77388 4.78283C4.74154 4.79661 4.70688 4.80371 4.67188 4.80371C4.63687 4.80371 4.60221 4.79661 4.56987 4.78283C4.53754 4.76904 4.50816 4.74883 4.48343 4.72335L0.671875 0.803711"
                                        stroke="#071655" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>

                            <mat-form-field>
                                <mat-date-range-input [dateFilter]="dateRangeFilter" [formGroup]="rangePickerForm"
                                    [rangePicker]="picker" #rangeInput>
                                    <input matStartDate placeholder="Start date" formControlName="startDate">
                                    <input matEndDate placeholder="End date" formControlName="endDate">
                                </mat-date-range-input>

                            </mat-form-field>
                            <mat-date-range-picker #picker (closed)="onBarChartFilterDateChange()"> </mat-date-range-picker>
                            <app-error-message [form]="rangePickerForm" controlName="endDate"></app-error-message>


                        </div> -->
                    </div>


                </div>

                <div class="graph d-flex justify-content-center mt-4">
                    <!-- <ngx-charts-line-chart [scheme]="lineChartColorScheme" [legend]="true" [xAxis]="showXAxis"
                        [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                        [legendTitle]="null" [autoScale]="false" [timeline]="" [results]="lineChartData"
                        [legendPosition]="legendPosition.Below">
                    </ngx-charts-line-chart> -->

                    <canvas id="pieChart">{{ pieChart }}</canvas>

                </div>
            </div>
        </div>

        <div class="col-12 mt-45">
            <div class="transaction-list">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="responsive-title" style="color: #2f2f2f;">ALL OFFICERS</h5>

                    <div class="d-flex gap-2 align-items-center flex-wrap">
                        <!-- <button *ngIf="transactions" class="custom-btn-primary" data-bs-toggle="dropdown"
                            (click)="attemptExport($event)">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3741 13.9445L12.568 11.7506V13.5528H13.3516V10.4186H10.2174V11.2021H12.0196L9.82562 13.3961L10.3741 13.9445ZM1.59835 14.3363C1.1674 14.3363 0.798346 14.1827 0.491195 13.8756C0.184043 13.5684 0.030729 13.1996 0.0312513 12.7692V1.79952C0.0312513 1.36857 0.184827 0.999518 0.491979 0.692367C0.79913 0.385215 1.16792 0.231901 1.59835 0.232423H12.568C12.999 0.232423 13.3681 0.385999 13.6752 0.69315C13.9824 1.0003 14.1357 1.36909 14.1351 1.79952V7.04931C13.887 6.93177 13.6324 6.83044 13.3712 6.74529C13.11 6.66014 12.8423 6.59824 12.568 6.55959V1.79952H1.59835V12.7692H6.33883C6.37801 13.0565 6.44017 13.3308 6.52531 13.5919C6.61046 13.8531 6.71154 14.1013 6.82855 14.3363H1.59835ZM1.59835 11.9857V12.7692V1.79952V6.55959V6.50082V11.9857ZM3.16545 11.2021H6.35842C6.39759 10.9279 6.45975 10.6602 6.5449 10.399C6.63005 10.1378 6.7246 9.88315 6.82855 9.63502H3.16545V11.2021ZM3.16545 8.06792H7.9451C8.363 7.67615 8.82973 7.34967 9.34531 7.08848C9.86088 6.8273 10.4128 6.651 11.0009 6.55959V6.50082H3.16545V8.06792ZM3.16545 4.93372H11.0009V3.36662H3.16545V4.93372ZM11.7845 15.9034C10.7006 15.9034 9.77652 15.5213 9.0123 14.7571C8.24808 13.9929 7.86623 13.0691 7.86675 11.9857C7.86675 10.9018 8.24886 9.97769 9.01308 9.21347C9.77731 8.44925 10.7011 8.0674 11.7845 8.06792C12.8684 8.06792 13.7925 8.45003 14.5567 9.21425C15.3209 9.97848 15.7028 10.9023 15.7022 11.9857C15.7022 13.0696 15.3201 13.9936 14.5559 14.7579C13.7917 15.5221 12.8679 15.9039 11.7845 15.9034Z"
                                    fill="white" />
                            </svg>


                            Export Data
                        </button> -->

                        <div class="dropdown-menu amc-table-action-select" [class.show]="dropdownOpen">
                            <div class="dropdown-wrapper">
                                <div class="action-btn" role="button" (click)="exportExcel(); $event.stopPropagation()">
                                    Excel
                                    <div class="spinner-light" *ngIf="isExportingExcel"></div>
                                </div>
                                <div class="action-btn" role="button" (click)="exportPdf(); $event.stopPropagation()">
                                    PDF
                                    <div class="spinner-light" *ngIf="isExportingPdf"></div>

                                </div>
                                <div class="action-btn" role="button" (click)="exportCsv(); $event.stopPropagation()">
                                    CSV
                                    <div class="spinner-light" *ngIf="isExportingCsv"></div>

                                </div>
                            </div>

                        </div>

                        <div class="search-container">
                            <div class="amc-search-bar" (click)="toggleShowSearch()">
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.2094 13.7386L12.9178 11.4981L12.8641 11.4164C12.7643 11.317 12.6277 11.261 12.4852 11.261C12.3426 11.261 12.2061 11.317 12.1062 11.4164C10.1587 13.2031 7.15783 13.3002 5.09373 11.6434C3.02964 9.98651 2.54284 7.08981 3.95619 4.87434C5.36953 2.65888 8.24444 1.81213 10.6743 2.89565C13.1041 3.97918 14.3349 6.65676 13.5504 9.15262C13.4939 9.33293 13.5401 9.52901 13.6716 9.66701C13.803 9.805 13.9998 9.86394 14.1878 9.82162C14.3757 9.7793 14.5263 9.64216 14.5828 9.46185C15.5207 6.49999 14.1042 3.3126 11.2498 1.9616C8.39539 0.610603 4.95962 1.50144 3.1651 4.05784C1.37058 6.61423 1.75585 10.069 4.07168 12.1872C6.38752 14.3055 9.93892 14.4515 12.4285 12.5308L14.4575 14.5146C14.6671 14.7186 15.0058 14.7186 15.2154 14.5146C15.4247 14.3077 15.4247 13.9746 15.2154 13.7678L15.2094 13.7386Z"
                                        fill="#667085" />
                                </svg> <span>Search</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="panel-div">
                    <div class="table-wrapper border-radius-full">

                        <form class="side-search-form" [formGroup]="searchForm"
                            [ngClass]="{ 'active': showSearchForm }">
                            <div class="dark-overlay" (click)="closeSearchForm()"></div>

                            <div class="side-search-form-container">
                                <div class="top">
                                    <h3 class="fw-bold">Search Filters</h3>
                                    <span class="material-symbols-outlined text-danger ms-auto" role="button"
                                        (click)="toggleShowSearch()">close</span>
                                </div>

                                <div class="filter-wrapper">

                                    <div class="message">
                                        Narrow down search results by using the options below. You must select at least
                                        one of the fields, then click Search.
                                    </div>
                                    <div class="row mt-2 g-3">
                                        <!-- Application Status -->
                                        <!-- <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Application Status</label>
                                                <select class="form-select small-option-font"
                                                    formControlName="applicationStatus">
                                                    <option value="">-- Select Status --</option>
                                                    <option value="PENDING">Pending</option>
                                                    <option value="APPROVED">Approved</option>
                                                    <option value="QUERIED">Queried</option>
                                                </select>
                                            </div>
                                        </div> -->
                                        <!-- Payment Status -->
                                        <!-- <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Payment Status</label>
                                                <select class="form-select small-option-font"
                                                    formControlName="paymentStatus">
                                                    <option value="">-- Select Status --</option>
                                                    <option value="PAID">Paid</option>
                                                    <option value="UNPAID">Unpaid</option>
                                                    <option value="PENDING">Pending</option>
                                                    <option value="FAILED">Failed</option>
                                                </select>
                                            </div>
                                        </div> -->
                                        <!-- Created By -->
                                        <!-- <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Created By</label>
                                                <ng-select [items]="[]" bindLabel="name" bindValue="id"
                                                    placeholder="-- Select Creator --" formControlName="createdBy">
                                                </ng-select>
                                            </div>
                                        </div> -->
                                        <!-- Zone -->
                                        <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Year</label>
                                                <ng-select [items]="past10Years" bindLabel="name" bindValue="id"
                                                    placeholder="-- Select Year --" formControlName="year">
                                                </ng-select>
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Month</label>
                                                <ng-select [multiple]="true" [items]="monthsOfYear" bindLabel="name"
                                                    bindValue="id" placeholder="-- Select Month(s) --"
                                                    formControlName="months">
                                                </ng-select>
                                            </div>
                                        </div>
                                        <!-- Tax Office -->
                                        <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Assessment Type</label>
                                                <ng-select [items]="assessmentTypes" bindLabel="category" bindValue="category"
                                                    placeholder="-- Select Assessment Type --"
                                                    formControlName="assessmentType">
                                                </ng-select>
                                            </div>
                                        </div>
                                        <!-- Officer -->
                                        <!-- <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Officers</label>
                                                <ng-select [items]="[]" bindLabel="name" bindValue="id"
                                                    placeholder="-- Select Officer --" formControlName="officer">
                                                </ng-select>
                                            </div>
                                        </div> -->
                                        <!-- Date -->
                                        <!-- <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Date</label>
                                                <input type="date" class="form-control" formControlName="date" />
                                            </div>
                                        </div> -->




                                        <!-- Search Button -->
                                        <div class="col-12 d-flex align-items-end">
                                            <button class="custom-btn-primary w-100"
                                                [disabled]="appliedFilterCount <= 0" (click)="fetchAssessmentTable()">
                                                Apply Search {{ appliedFilterCount > 0 ? 'Filter' + (appliedFilterCount
                                                > 1 ? 's' : '') + ' (' + appliedFilterCount + ')' : 'Filter' }}
                                            </button>
                                        </div>
                                        <!-- Clear & Close -->
                                        <div class="actions d-flex justify-content-end">
                                            <span class="clear-all-btn" role="button"
                                                (click)="clearSearchFilters()">Clear
                                                all filters</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>


                        <table class="role-table amc-table" appAutoDataLabel>
                            <thead class="amc-table-heading">
                                <tr>
                                    <th>S/N</th>
                                    <th>Month</th>
                                    <th>Total Assessments</th>
                                    <th>Approved Assessments</th>
                                    <th>Paid Assessments</th>
                                    <th>Pending Assessments</th>
                                    <th>Total Assessment Amount</th>
                                    <th>Amount Paid</th>
                                    <th>Amount Unpaid</th>
                                    <th>Approval Rate</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let transaction of transactions; let i = index">
                                    <td>
                                        {{ i + (pageSize * (currentPage - 1)) + 1 }}
                                    </td>
                                    <td>
                                        {{ transaction?.month | titlecase }}
                                    </td>
                                    <td>
                                        {{ transaction?.totalCount | number }}
                                    </td>
                                    <td>
                                        {{ transaction?.approveCount | number }}
                                    </td>
                                    <td>
                                        {{ transaction?.paidCount | number }}
                                    </td>
                                    <td>
                                        {{ transaction?.pendingCount | number }}
                                    </td>
                                    <td>
                                        {{( transaction?.paidAmount || 0) + (transaction?.unpaidAmount || 0) | nairaCurrency }}
                                    </td>
                                    <td>
                                        {{ transaction?.paidAmount | nairaCurrency }}
                                    </td>
                                    <td>
                                        {{ transaction?.unpaidAmount | nairaCurrency }}
                                    </td>

                                    <td [ngClass]="{
                                        'text-success': transaction?.approvePercentage > 75,
                                        'text-warning': transaction?.approvePercentage > 49 && transaction?.approvalRate <= 75,
                                        'text-danger': transaction?.approvePercentage <= 49
                                      }">
                                        {{ transaction?.approvePercentage }}%
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                        @if(errorFetchingTransactionHistory) {
                        <p class="text-center text-danger p-3">Error Fetching Data</p>
                        }

                        @if(isSearching) {
                        <div class="p-4">
                            <app-bounce-loader></app-bounce-loader>
                        </div>
                        }

                        @if(searchedtransactionsNotFound) {
                        <p class="text-center text-danger p-3">There are no items found that fit this search criteria...
                        </p>
                        }
                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">
                    <div class="d-flex align-items-center me-4">
                        <div>Rows per page:</div>
                        <div class="mx-2">
                            <select class="form-control px-6 text-center" style="width: auto; min-width: 40px"
                                [(ngModel)]="selectedLimit" (change)="updateLimit()">
                                <option [value]="10">10</option>
                                <option [value]="20">20</option>
                                <option [value]="30">30</option>
                                <option [value]="40">40</option>
                                <option [value]="50">50</option>
                            </select>
                        </div>
                    </div>

                    <div class="pagination-container">
                        <ngb-pagination *ngIf="!isSearching && count > 0" [(page)]="currentPage"
                            (pageChange)="onPageChange($event)" [maxSize]="5" [pageSize]="pageSize"
                            [collectionSize]="count" [boundaryLinks]="true" [directionLinks]="true" [rotate]="true"
                            class="pagination justify-content-center my-3">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>










</div>

<!-- <app-bounce-loader></app-bounce-loader> -->